import Fields from '@/views/backstage/structure/digital_object_page/common/DigitalObjectFields'

let fields_type_II = [].concat(
    Fields['digital_type'], 
    Fields['preview_picture'],
    Fields['original_image'],
    Fields['carrier_type'],
    Fields['carrier_location'],
    Fields['description'])

let official_document_structure = {
    name: '公文類',
    type: 'group',
    fields: fields_type_II
}
    
let graph_structure = {
    name: '圖說(技術文件)',
    type: 'group',
    fields: fields_type_II
}

let publication_structure = {
    name: '出版品',
    type: 'group',
    fields: fields_type_II
}

let image_structure = {
    name: '影像',
    type: 'group',
    fields: fields_type_II
}

let cultural_relics_structure = {
    name: '文物器具類',
    type: 'group',
    fields: fields_type_II
}

let oral_history_structure = {
    name: '口述歷史類',
    type: 'group',
    fields: fields_type_II
}

let culture_natural_landscape_structure = {
    name: '文化、自然景觀類',
    type: 'group',
    fields: fields_type_II
}

let buildings_structure = {
    name: '建築物、土木設施與遺址類',
    type: 'group',
    fields: fields_type_II
}

export default (digital_object_detail_page_type) => {
    switch (digital_object_detail_page_type) {
    case 'official_document': return official_document_structure;
    case 'graph': return graph_structure;
    case 'publication': return publication_structure;
    case 'image': return image_structure;
    case 'cultural_relics': return cultural_relics_structure;
    case 'oral_history': return oral_history_structure;
    case 'culture_natural_landscape': return culture_natural_landscape_structure;
    case 'buildings': return buildings_structure;
    default: return []
    }
}